import { Widget, WIDGET_LIVESETTLEMENTS } from "@gaming/srvg-classes-core";

export class LivesettlementsWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#livesettlementwidget';
        super( options );

        this.name = 'widgetlivesettlements';
        this.widgetName = options.widgetName || WIDGET_LIVESETTLEMENTS;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {};

        // Pal.Avv.
        if (! options.approvalCodeLabel){
            this.widgetOptions.approvalCodeLabel = __('Pal.Avv.');
        }
        if(srvg && srvg.config && srvg.config.modeItaly && srvg.config.modeItaly === true){
            this.widgetOptions.showApprovalCode = true;
        }

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        if( !this.widgetOptions.hasOwnProperty('height') ) {
            this.widgetOptions.height = this.getContainerHeightWithUnit();
        }
        this.addLivesettlementsWidget();
        super.handleDomInstantiated();
    }

    /**
     * add livesettlements widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addLivesettlementsWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        if (app.timeline.currentChannel){
            this.widgetOptions.selectedChannel = app.timeline.currentChannel;
        }

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addLivesettlementsWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(selector, eventdata){
        this.addLivesettlementsWidget(selector);
    }


    /**
     * setMarkets
     * will destory widget and recreate with old options except
     * @param array markets array with strings with betting markets
     */
    setMarkets(markets){
        this.widgetOptions.marketsOverride = markets;
        this.widgetOptions.height = this.getContainerHeightWithUnit();

        this.widget.destroy();
        this.addLivesettlementsWidget();
    }

    /**
     * calls widget api setChannel to switch channel
     * it is not necessary to switch the channel if livescore widget is connected with widget via widget group
     * @param number channel equivalent to videochannel
     */
    setChannel(channel?: number){
        if(this.widget.api){
            this.widget.api.setChannel(channel);
        }
    }


    /**
     * calls widget api setMatch to switch match information
     * it is not necessary to switch the information if it is conntected to livescore widget
     * @param number match id
     */
    setMatch(matchId?: number){
        if(this.widget.api){
            this.widget.api.setMatch(matchId);
        }
    }





}
